import { AddUpdateAssessmentViolationComponent } from "./add-update-assessment-violation.component";
export var AddUpdateAssessmentViolationModule = angular
    .module('addUpdateAssessmentViolation', [])
    .component(AddUpdateAssessmentViolationComponent.selector, AddUpdateAssessmentViolationComponent.component)
    .name;
//# sourceMappingURL=add-update-assessment-violation.module.js.map